module.exports = "<div class=\"alg-document-needed\">\n  <div class=\"image\">\n    <img src=\"../../../../assets/images/doc_{{ image }}.png\" alt=\"\">\n  </div>\n  <div class=\"title\">{{ title }}</div>\n  <div class=\"subtitle\">{{ subtitle }}</div>\n  <div [class.isMobile]=\"txtMobile\" class=\"txt\">{{ txt }}</div>\n  <div class=\"txtMobile\">{{ txtMobile }}</div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-document-needed/alg-document-needed.component.html
// module id = ./src/app/components/molecules/alg-document-needed/alg-document-needed.component.html
// module chunks = main